module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5MpeJP/tc-custom/9781035802760.jpg?1728353212379",
      "alt": "This image is the cover for the book The Secret Sign"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Secret Sign\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Zara, a young slave girl, is thrilled to discover a mysterious secret sign scrawled in the dust. Hoping it will lead to the promised ‘power that is not cruel’ she desperately seeks for her temperamental master, Zara must navigate the treacherous world of slavery, unsure if she can trust her fellow slaves. When an accident forces her to flee, Zara encounters the enigmatic ‘people of the sign.’ As a burning Rome is left behind, Zara’s entire family journeys to a distant, more primitive land. Faced with arduous work, new dangers, and thrilling adventures, they forge friendships and confront unexpected challenges. When a family member is kidnapped and Zara’s fellow slave Andreas absconds, the stakes grow higher. Penniless, Andreas attempts to return to Rome, but will he succeed? And if he does, what fate awaits him in the city?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christine R. Regas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Christine R. Regas started writing short playlets for Brownies to act, culminating in a full-length ‘Panto rhyme’ (i.e., pantomime in rhyme). Later, she was asked to write Children’s Look In for her church newspaper, which is where an early part of The Secret Sign began. This continued for several years and three or four articles were also published in Together with Children, a Christian resource magazine now out of print. She has also written articles for adults on the church paper and some sketches to be acted out in church.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0